module.exports = __webpack_public_path__ + "static/media/E_SDG-goals_icons-individual-rgb-16-768x768.d373aafa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/E_SDG-goals_icons-individual-rgb-16-768x768.png
// module id = 1184
// module chunks = 0